import { useState, useRef, useEffect } from 'react'
import { UploadItem } from '@wellesley/uploads'

type UseUploadBatchResult = {
  uploadingItems: UploadItem[]
  isUploading: boolean
  startUploadBatch: () => void
}

export const useUploadBatch = (
  attachments: UploadItem[],
): UseUploadBatchResult => {
  const [uploadingItems, setUploadingItems] = useState<UploadItem[]>([])
  const [isUploading, setIsUploading] = useState(false)
  const uploadBatchStartIndexRef = useRef<number>(0)

  const startUploadBatch = () => {
    uploadBatchStartIndexRef.current = attachments.length
    setIsUploading(true)
  }

  const uploadStatusKey = attachments
    .map((a) => `${a.id}:${a.uploadId || 'pending'}`)
    .join(',')

  useEffect(() => {
    if (!isUploading) return

    const currentBatchItems = attachments.slice(
      uploadBatchStartIndexRef.current,
    )
    if (currentBatchItems.length > 0) {
      setUploadingItems([...currentBatchItems])
    }
  }, [attachments, isUploading, uploadStatusKey])

  return {
    uploadingItems,
    isUploading,
    startUploadBatch,
  }
}
